export default function initYouTubeApi() {
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function initYouTubePlayers() {
  const players = document.querySelectorAll(".js-youtube-player");

  if (players) {
    players.forEach((el, i) => {
      const videoWrapper = el.querySelector(".js-video-wrapper");

      //YT is defined on the window level by the above function
      const player = new YT.Player(videoWrapper, {
        height: "auto",
        width: "100%",
        videoId: el.dataset.id,
        playerVars: {
          rel: 0,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      });

      const playBtn = el.querySelector(".js-video-api-play");

      if (playBtn) {
        playBtn.addEventListener("click", function () {
          player.playVideo();
          el.classList.add("video-api-player--has-started");
        });
      }
    });
  }
}

function onPlayerReady(e) {}

function onPlayerStateChange() {}

//when api loads this function is called
window.onYouTubeIframeAPIReady = initYouTubePlayers;
